unit FsKontrolleEdit;

interface

uses
  System.SysUtils, System.Classes, System.StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Storage,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.GIFImg, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.WebCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCTabSet,
  VCL.TMSFNCListBox, WEBLib.Lists, WEBLib.SignatureCapture, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2, VCL.TMSFNCPanel, VCL.TMSFNCButton, Vcl.Mask,
  WEBLib.Mask, WEBLib.NFC;

[async] function DoFsKontrolleEdit( var aID_FsKontrolle  : Integer ) : TModalResult; async;

type
  TfrmFsKontrolleEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbMaBelegCaption: TLabel;
    lbEntladung: TLabel;
    [async]
    lbMaBelegID: TLabel;
    lbMitarbeiter: TLabel;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    WebNFC: TNFC;
    WebLabel1: TLabel;
    edtDatum: TDateTimePicker;
    btnScannNfc: TTMSFNCToolBarButton;
    edtMaCode: TEdit;
    edtCode: TEdit;
    btnSetcode: TButton;
    lbStatus: TLabel;
    WebLabel3: TLabel;
    lbBemerkung: TLabel;
    mBemerkung: TMemo;
    procedure WebFormResize(Sender: TObject);
     //
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure Form_Uebersetzen; async;
     //
    procedure btnOKClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebNFCReading(Sender: TObject; ASerialNumber: string; AData: TJSNDEFMessageRecord);
    procedure btnScannNfcClick(Sender: TObject);
    procedure btnSetcodeClick(Sender: TObject);

  private
    iID_FsKontrolle  : Integer;
    bFertig : Boolean;
    sMaCode : String;
    sCode   : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmFsKontrolleEdit: TfrmFsKontrolleEdit;

const cFormMaBelegEdit = 'FSKONTROLLEEDIT_';

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb , SpediFucsDatenmodul, ShowGrafik ;


//================================================================================================//

function DoFsKontrolleEdit( var aID_FsKontrolle  : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmFsKontrolleEdit := TfrmFsKontrolleEdit.Create(application);
  frmFsKontrolleEdit.Popup   := True;
  frmFsKontrolleEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmFsKontrolleEdit.iID_FsKontrolle  := aID_FsKontrolle;


  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmFsKontrolleEdit, frmFsKontrolleEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmFsKontrolleEdit.Resize;

  Try
    await( TModalResult, frmFsKontrolleEdit.Execute);  // excute form and wait for close

    Result := frmFsKontrolleEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        await( frmFsKontrolleEdit.Daten_Speichern );
        aID_FsKontrolle := frmFsKontrolleEdit.iID_FsKontrolle;
      End;
//
  Finally
    frmFsKontrolleEdit.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.Opt_Speichern;
begin

  //TWebLocalStorage.SetValue( cFormMaBelegEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.Opt_Laden;
begin
  //pgContr.ActivePageIndex := StrToIntDef( TWebLocalStorage.GetValue( cFormMaBelegEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.btnOKClick(Sender: TObject);
begin
  inherited;

  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.btnScannNfcClick(Sender: TObject);
begin
  inherited;
  WebNfc.Scan;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.btnSetcodeClick(Sender: TObject);
begin
  inherited;
  self.sCode := edtCode.Text;
end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sInfo, sKopfZeile: String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
    li: TListItem;
begin

  console.log('TfrmFsKontrolleEdit.Daten_Laden - Start '+IntToStr(self.iID_FsKontrolle) );

  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL := '01:SELECT K.*, '

            +'  (SELECT NFCTAG FROM MITARBEITER M WHERE M.ID_MITARBEITER=K.ID_MITARBEITER ) as NFCTAG , '

            + ' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
            +'   FROM ADRESSE A, MITARBEITER M  '
            +'   WHERE A.ID_ADRESSE=M.ID_ADRESSE AND M.ID_MITARBEITER=K.ID_MITARBEITER ) as MAB '

            +' FROM FSKONTROLLE K WHERE K.ID_FSKONTROLLE='+IntToStr(self.iID_FsKontrolle) +';'
        ;
  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  mBemerkung.Clear;


  // Führerschein-Kontrolle ---------------------------------------------------------
  //
  If self.iID_FsKontrolle = 0 then
    Begin
      lbMaBelegCaption.Caption := 'Führerschein-Kontrolle anlegen...';
      edtDatum.DateTime := Date;
      edtDatum.Enabled  := True;
      lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;

      lbMaBelegID.Caption := '';
      lbStatus.Caption := '';
      bFertig := False;
    End
  Else
    Begin
      lbMaBelegCaption.Caption := 'Führerschein-Kontrolle bearbeiten...';

      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

      sFelder := aSL[1];
      sDaten  := aSL[2];

      lbMaBelegID.Caption := 'Nr: '+ GetFeldWert( sFelder, sDaten, 'ID_FSKONTROLLE'  );

      bFertig := SToB( GetFeldWert( sFelder, sDaten, 'FERTIG' )  );
      lbStatus.Caption := GetFeldWert( sFelder, sDaten, 'FERTIG_AM'  );

      edtDatum.Date    := StrToDateTime(  GetFeldWert( sFelder, sDaten, 'DATUM' )  );
      edtDatum.Enabled := False;

      lbMitarbeiter.Caption := GetFeldWert( sFelder, sDaten, 'MAB'  );

      sTmp := GetFeldWert( sFelder, sDaten, 'BEMERKUNG'  );
      mBemerkung.Text := ReplaceStr( sTmp, '##', chr(13)+chr(10) );

    End;

  sMaCode := GetFeldWert( sFelder, sDaten, 'NFCTAG'  );
  edtMaCode.Text := sMACode;

  sCode := GetFeldWert( sFelder, sDaten, 'CODE'  );
  edtCode.Text := sCode;


  If (self.bFertig=False) and (sMaCode<>'') and IsNFCSupported and frmMainForm.IstHttps then
      btnScannNfc.Enabled := True
  Else
    Begin
       lbBemerkung.Caption := 'NFC-Scann nur möglich unter: HTTPS/Android/Chrome';
       lbBemerkung.Font.Color := clRed;
    End;


  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmFsKontrolleEdit.Daten_Laden - Ende '+IntToStr(self.iID_FsKontrolle) );

end;

//================================================================================================//

function TfrmFsKontrolleEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL : String;
    aObj : TParam;
    iErg : Integer;
begin

  If self.iID_FsKontrolle=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr,0);
      aObj.Datum1 := Date;
      aObj.String1 := frmMainForm.User_Account;

      ClientConn := TXDataWebClient.Create(nil);
      ClientConn.Connection := frmMainForm.XDataConn;

      Response := await( ClientConn.RawInvokeAsync('ISystemService.FsKontrolleIns', [ aObj] ));

      iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

      self.iID_FsKontrolle := iErg;

      ClientConn.Free;
      aObj.Free;

      console.log('angelegt...' +Inttostr(self.iID_FsKontrolle)   );

    End;

  sSQL := 'UPDATE FSKONTROLLE SET '
        +' DATUM = '+cH+DateTimeToStr(edtDatum.DateTime)+cH  +', '
        +' BEMERKUNG = '+cH+Trim(mBemerkung.Text)+cH ;

  If (self.bFertig=False) and (self.sMaCode<>'') and (self.sCode<>'')  and  (self.sMaCode=self.sCode) then
     sSQL := sSQL +  ', FERTIG = 1 '
                    +', FERTIG_AM = '+cH+DateTimeToStr(Now)+cH
                    +', FERTIG_USER = '+ cH+ frmMainForm.User_Account+cH
                    +', CODE = '+ cH+ self.sCode +cH ;

  sSQL := sSQL  +' WHERE ID_FSKONTROLLE='+IntToStr(self.iID_FsKontrolle)  +';' ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  sSQL := await( Crypt( sSQL ));

  Response := await( ClientConn.RawInvokeAsync('ISystemService.SetDatenPaket', [ sSQL ] ) );
  Blob := Response.Result;

  ClientConn.Free;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  Opt_Laden;
end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.WebFormResize(Sender: TObject);
begin

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;

  // Komponenten
  iZielBreite := Trunc( self.Width * 0.95 );
  If iZielBreite > 500 then iZielBreite := 500;

  lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  Sprach_Daten_Laden('FSKONTROLLEEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;

  If edtDatum.CanFocus then edtDatum.SetFocus;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.WebNFCReading(Sender: TObject; ASerialNumber: string; AData: TJSNDEFMessageRecord);
begin
  inherited;

  self.sCode := ASerialNumber;
  edtCode.Text := self.sCode;

  WebNfc.Stop;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmSchadenEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmSchadenEdit');

//  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;

 self.bUebersetzt := True;

end;

//====================================================================================================================//

procedure TfrmFsKontrolleEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  lbStatus := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lbBemerkung := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  lbMaBelegCaption := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  lbMaBelegID := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  edtDatum := TDateTimePicker.Create(Self);
  btnScannNfc := TTMSFNCToolBarButton.Create(Self);
  edtMaCode := TEdit.Create(Self);
  edtCode := TEdit.Create(Self);
  btnSetcode := TButton.Create(Self);
  mBemerkung := TMemo.Create(Self);
  WebNFC := TNFC.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lbBemerkung.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbMaBelegCaption.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  lbMaBelegID.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  edtDatum.BeforeLoadDFMValues;
  btnScannNfc.BeforeLoadDFMValues;
  edtMaCode.BeforeLoadDFMValues;
  edtCode.BeforeLoadDFMValues;
  btnSetcode.BeforeLoadDFMValues;
  mBemerkung.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  WebNFC.BeforeLoadDFMValues;
  try
    Width := 514;
    Height := 481;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 106;
    WebLabel1.Width := 42;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Datum';
    WebLabel1.Color := 16776441;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(Self);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 80;
    lbStatus.Top := 146;
    lbStatus.Width := 82;
    lbStatus.Height := 16;
    lbStatus.Caption := '26.08.2025';
    lbStatus.Color := 16776441;
    lbStatus.Font.Charset := ANSI_CHARSET;
    lbStatus.Font.Color := clWindowText;
    lbStatus.Font.Height := -13;
    lbStatus.Font.Name := 'Verdana';
    lbStatus.Font.Style := [fsBold];
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.ParentFont := False;
    lbStatus.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 146;
    WebLabel3.Width := 44;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Fertig:';
    WebLabel3.Color := 16776441;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lbBemerkung.SetParentComponent(Self);
    lbBemerkung.Name := 'lbBemerkung';
    lbBemerkung.Left := 16;
    lbBemerkung.Top := 178;
    lbBemerkung.Width := 71;
    lbBemerkung.Height := 16;
    lbBemerkung.Caption := 'Bemerkung';
    lbBemerkung.Color := 16776441;
    lbBemerkung.HeightPercent := 100.000000000000000000;
    lbBemerkung.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 514;
    WebPanel1.Height := 84;
    WebPanel1.Align := alTop;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 2;
    lbMaBelegCaption.SetParentComponent(WebPanel1);
    lbMaBelegCaption.Name := 'lbMaBelegCaption';
    lbMaBelegCaption.Left := 157;
    lbMaBelegCaption.Top := 5;
    lbMaBelegCaption.Width := 186;
    lbMaBelegCaption.Height := 18;
    lbMaBelegCaption.Caption := 'F'#252'hrerschein-Kontrolle';
    lbMaBelegCaption.Font.Charset := DEFAULT_CHARSET;
    lbMaBelegCaption.Font.Color := clBlack;
    lbMaBelegCaption.Font.Height := -15;
    lbMaBelegCaption.Font.Name := 'Verdana';
    lbMaBelegCaption.Font.Style := [fsBold];
    lbMaBelegCaption.HeightPercent := 100.000000000000000000;
    lbMaBelegCaption.ParentFont := False;
    lbMaBelegCaption.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 57;
    lbEntladung.Width := 71;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Mitarbeiter';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    lbMaBelegID.SetParentComponent(WebPanel1);
    lbMaBelegID.Name := 'lbMaBelegID';
    lbMaBelegID.Left := 157;
    lbMaBelegID.Top := 29;
    lbMaBelegID.Width := 41;
    lbMaBelegID.Height := 18;
    lbMaBelegID.Caption := 'Nr: 0';
    lbMaBelegID.Font.Charset := ANSI_CHARSET;
    lbMaBelegID.Font.Color := clWindowText;
    lbMaBelegID.Font.Height := -15;
    lbMaBelegID.Font.Name := 'Verdana';
    lbMaBelegID.Font.Style := [fsBold];
    lbMaBelegID.HeightPercent := 100.000000000000000000;
    lbMaBelegID.ParentFont := False;
    lbMaBelegID.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 103;
    lbMitarbeiter.Top := 57;
    lbMitarbeiter.Width := 71;
    lbMitarbeiter.Height := 16;
    lbMitarbeiter.Caption := 'T0000000';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -13;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 72;
    btnOK.Top := 3;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 3;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    edtDatum.SetParentComponent(Self);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 74;
    edtDatum.Top := 100;
    edtDatum.Width := 135;
    edtDatum.Height := 28;
    edtDatum.Cursor := crHandPoint;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.ChildOrder := 5;
    edtDatum.Color := 15329769;
    edtDatum.Date := 45767.262767685180000000;
    edtDatum.Role := '';
    edtDatum.ShowSeconds := False;
    edtDatum.Text := '';
    btnScannNfc.SetParentComponent(Self);
    btnScannNfc.Name := 'btnScannNfc';
    btnScannNfc.Left := 235;
    btnScannNfc.Top := 100;
    btnScannNfc.Width := 125;
    btnScannNfc.Height := 44;
    btnScannNfc.Cursor := crHandPoint;
    btnScannNfc.ParentDoubleBuffered := False;
    btnScannNfc.DoubleBuffered := True;
    btnScannNfc.Enabled := False;
    btnScannNfc.Font.Charset := ANSI_CHARSET;
    btnScannNfc.Font.Color := clWindowText;
    btnScannNfc.Font.Height := -13;
    btnScannNfc.Font.Name := 'Verdana';
    btnScannNfc.Font.Style := [];
    btnScannNfc.ParentColor := True;
    btnScannNfc.TabOrder := 1;
    SetEvent(btnScannNfc, Self, 'OnClick', 'btnScannNfcClick');
    btnScannNfc.Text := 'Scannen';
    btnScannNfc.BitmapContainer := BitmapCont;
    btnScannNfc.ControlIndex := 0;
    edtMaCode.SetParentComponent(Self);
    edtMaCode.Name := 'edtMaCode';
    edtMaCode.Left := 370;
    edtMaCode.Top := 97;
    edtMaCode.Width := 121;
    edtMaCode.Height := 22;
    edtMaCode.ChildOrder := 7;
    edtMaCode.HeightPercent := 100.000000000000000000;
    edtMaCode.Visible := False;
    edtMaCode.WidthPercent := 100.000000000000000000;
    edtCode.SetParentComponent(Self);
    edtCode.Name := 'edtCode';
    edtCode.Left := 370;
    edtCode.Top := 121;
    edtCode.Width := 121;
    edtCode.Height := 22;
    edtCode.ChildOrder := 7;
    edtCode.HeightPercent := 100.000000000000000000;
    edtCode.Visible := False;
    edtCode.WidthPercent := 100.000000000000000000;
    btnSetcode.SetParentComponent(Self);
    btnSetcode.Name := 'btnSetcode';
    btnSetcode.Left := 395;
    btnSetcode.Top := 149;
    btnSetcode.Width := 96;
    btnSetcode.Height := 25;
    btnSetcode.Caption := 'set code';
    btnSetcode.ChildOrder := 9;
    btnSetcode.HeightPercent := 100.000000000000000000;
    btnSetcode.Visible := False;
    btnSetcode.WidthPercent := 100.000000000000000000;
    SetEvent(btnSetcode, Self, 'OnClick', 'btnSetcodeClick');
    mBemerkung.SetParentComponent(Self);
    mBemerkung.Name := 'mBemerkung';
    mBemerkung.Left := 8;
    mBemerkung.Top := 200;
    mBemerkung.Width := 495;
    mBemerkung.Height := 253;
    mBemerkung.Anchors := [akLeft,akTop,akRight,akBottom];
    mBemerkung.Font.Charset := ANSI_CHARSET;
    mBemerkung.Font.Color := clWindowText;
    mBemerkung.Font.Height := -13;
    mBemerkung.Font.Name := 'Verdana';
    mBemerkung.Font.Style := [];
    mBemerkung.HeightPercent := 100.000000000000000000;
    mBemerkung.ParentFont := False;
    mBemerkung.SelLength := 0;
    mBemerkung.SelStart := 0;
    mBemerkung.WidthPercent := 100.000000000000000000;
    tabSprachDaten.Left := 368;
    tabSprachDaten.Top := 16;
    WebNFC.SetParentComponent(Self);
    WebNFC.Name := 'WebNFC';
    SetEvent(WebNFC, Self, 'OnReading', 'WebNFCReading');
    WebNFC.Left := 240;
    WebNFC.Top := 259;
  finally
    WebLabel1.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lbBemerkung.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbMaBelegCaption.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    lbMaBelegID.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    edtDatum.AfterLoadDFMValues;
    btnScannNfc.AfterLoadDFMValues;
    edtMaCode.AfterLoadDFMValues;
    edtCode.AfterLoadDFMValues;
    btnSetcode.AfterLoadDFMValues;
    mBemerkung.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    WebNFC.AfterLoadDFMValues;
  end;
end;

end.
